import React from 'react';
import {
  Banner,
  BannerImage,
  BannerContent,
  BackBtn,
  BannerTitle,
  BannerDescription,
  BannerActions,
  BtnPrimary,
  BtnAddLot,
  BtnSecondary,
  BtnSecondaryCyan,
} from './styled';

export default React.memo(function StoreBanner({
  storeName,
  shortDescription,
  coverImage,
  onBack,
  onAddProduct,
  onAddLot,
  onCreateGroup,
  onImportProducts,
  isStoreOwner,
}) {
  return (
    <Banner>
      {coverImage && (
        <BannerImage
          src={coverImage}
          alt={storeName}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      )}
      <BannerContent>
        <BackBtn type="button" onClick={onBack}>
          ← Back to Stores
        </BackBtn>
        <BannerTitle>{storeName || 'Store'}</BannerTitle>
        {shortDescription && (
          <BannerDescription>{shortDescription}</BannerDescription>
        )}
        {isStoreOwner && (
          <BannerActions>
            <BtnPrimary type="button" onClick={onAddProduct}>
              + Add Product
            </BtnPrimary>
            <BtnAddLot type="button" onClick={onAddLot}>
              + Add Lot
            </BtnAddLot>
            <BtnSecondary type="button" onClick={onCreateGroup}>
              + Create Purchase Group
            </BtnSecondary>
            <BtnSecondaryCyan type="button" onClick={onImportProducts}>
              + Import Products
            </BtnSecondaryCyan>
          </BannerActions>
        )}
      </BannerContent>
    </Banner>
  );
});
